import { config } from 'src/config';

export const resolveCompanyLogoUrl = (
  logo: string | null | undefined
): string | undefined => {
  const value = logo?.trim();
  if (!value) return undefined;
  if (/^https?:\/\//i.test(value)) return value;

  const filename = value.replace(/^\/+/, '');
  const fileBase = (config.FILe_URL || '').replace(/\/+$/, '');
  return fileBase ? `${fileBase}/${filename}` : `/${filename}`;
};
